<div class="content">
  <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutGap=".5rem" data-qa="file-message">
    @if (fileExist) {
      <mat-icon (click)="download()" style="cursor: pointer">picture_as_pdf</mat-icon>
      <span>{{currentFile.name}}</span>
    } @else {
      <mat-icon>warning</mat-icon>
      <span>Bedienungsanleitung nicht vorhanden</span>
    }
  </div>
  <form>
    <div class="upload" data-qa="file-upload-button">
      <button matButton="filled"
        (click)="fileInput.click()">
        <mat-icon>queue</mat-icon>
        Upload
      </button>
      <input hidden
        type="file"
        #fileInput
        data-qa="file-input"
        accept="application/pdf"
        (change)="onFileChanged()"/>
    </div>
  </form>

  <button matButton="filled" class="button-warn"
    data-qa="file-delete-button"
    [disabled]="!fileExist"
    (click)="delete()">
      <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
    Löschen
  </button>
</div>
